export const SDK_VERSION = '8.12.0';
